import { runOnceOnElement, currencyToNumber } from 'larasnap/support';

$.fn.forEach = function (f) {
    $(this).each(function () {
        f($(this));
    });
};

$.fn.elements = function () {
    const elements = [];
    $(this).each(function () {
        elements.push($(this));
    });
    return elements;
};

$.fn.hasInstance = function () {
    return !!$(this).data('instance');
};

$.fn.getInstance = function () {
    return $(this).data('instance');
};

$.fn.datamodel = function (name = null) {
    const element = name
        ? $(this).find(`.datamodel[data-name='${name}']`)
        : $(this).find('.datamodel');

    if (element.length > 0) {
        return element.data('instance');
    }

    if (!$(this).hasClass('panel-wrapper')) {
        const modal = $(this).closest('.panel-wrapper'); // {change}
        if (modal.length > 0) {
            return modal.datamodel(name);
        }
    }
};

$.fn.panel = function () {
    const panel = $(this).closest('.panel-wrapper');
    if (panel.length > 0) {
        return panel.data('instance');
    }
};

$.fn.vueApp = function (name = null) {
    const element = name
        ? $(this).find(`.vue-app-instance[data-name='${name}']`)
        : $(this).find('.vue-app-instance');

    if (element.length > 0) {
        return element.data('instance');
    }

    if (!$(this).hasClass('panel-wrapper')) {
        const modal = $(this).closest('.panel-wrapper'); // {change}
        if (modal.length > 0) {
            return modal.vueApp(name);
        }
    }
};

$.fn.snapgrid = function (name = null) {
    let selector = '.snapgrid-wrapper';

    if (typeof name === 'string' && name.startsWith('#')) {
        selector === `[data-id="${name.substr(1)}"]`;
    } else if (name) {
        selector += `[data-name="${name}"]`;
    }

    const grid = $(this).find(selector);
    if (grid.length > 0) {
        return grid.data('instance');
    }
};

$.fn.context = function () {
    const panel = $(this).closest('.panel-wrapper');
    if (panel.length > 0) {
        return panel;
    } else {
        return $('body');
    }
};

const initOnce = fn =>
    function (...args) {
        this.each(function () {
            runOnceOnElement($(this), fn, ...args);
        });
    };

$.fn.currencyInput = initOnce((el, extraOptions = {}) => {
    const setValue = val =>
        el.val(
            new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                ...el.data('options'),
                ...extraOptions,
            })
                .format(val)
                .replace('$', ''),
        );

    // Initialize value
    setValue(el.val());

    // Add interface enhancements
    el.wrap($("<div class='currency-edit'/>"));
    el.before('<span class="symbol">$</span>');

    // Define event handlers
    el.focus(function () {
        if (Number($(this).val()) === 0) {
            $(this).val('');
        }
    });

    el.on('blur change', function () {
        const val = currencyToNumber($(this).val().trim());
        setValue(Number(val) ? val : 0);
    });
});

$.fn.percentageInput = initOnce(el => {
    const setValue = val =>
        el.val(
            new Intl.NumberFormat('en-US', {
                maximumFractionDigits: Number(el.data('decimals')),
                minimumFractionDigits: Number(el.data('decimals')),
            }).format(val),
        );

    const formatValue = val => {
        if (isNaN(val)) return 0;

        val = Number(val);
        if (val > 100) {
            return 100;
        } else if (val < 0) {
            return 0;
        } else {
            return val;
        }
    };

    // Initialize value
    const val = formatValue(el.val());
    setValue(val * 100);

    // Add interface enhancements
    el.wrap('<div class="percentage-edit"/>');
    el.before('<span class="symbol">%</span>');

    // Define event handlers
    el.on('blur change', function () {
        setValue(formatValue($(this).val()));
    });
});
